import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=43bf35cd&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"
import style0 from "./Activities.vue?vue&type=style&index=0&id=43bf35cd&prod&scoped=true&lang=css"
import style1 from "./Activities.vue?vue&type=style&index=1&id=43bf35cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bf35cd",
  null
  
)

export default component.exports